export const SUCCESS_ALERT = "success";
export const ERROR_ALERT = "error";

export const WARNING_ALERT = "warning";
export const INFO_ALERT = "info";

export const CLEAR_STATE = "CLEAR_STATE";
